import {
  type ColumnIdentifier,
  columnIdentityComparator,
  type ColumnSettings,
  MAGIC_AUTO_COLUMN_WIDTH,
  NEPTUNE_COLUMN_IDS,
} from '@neptune/shared/leaderboard-domain';

export const myRunsDefaultColumnsSettings: ColumnSettings[] = [
  // TODO: Enable once bulk operations are ready FO-244
  // {
  //   id: NEPTUNE_COLUMN_IDS.SELECTION,
  //   // this type is just virtual as this column is represented by its own specific renderer
  //   columnType: 'string',
  //   exportable: false,
  //   groupable: false,
  //   hideable: false,
  //   pinned: true,
  //   reorderable: {
  //     draggable: false,
  //   },
  //   resizable: false,
  //   sortable: false,
  //   width: 24,
  //   renamable: false,
  //   recolorable: false,
  // },
  {
    id: NEPTUNE_COLUMN_IDS.NAME,
    columnType: 'string',
    exportable: true,
    groupable: false,
    hideable: false,
    pinned: false,
    reorderable: {
      draggable: false,
    },
    resizable: true,
    sortable: true,
    width: MAGIC_AUTO_COLUMN_WIDTH,
    autoWidthEnabled: true,
    renamable: false,
    recolorable: false,
  },
  {
    id: 'project',
    // this type is just virtual as this column is represented by its own specific renderer
    columnType: 'string',
    displayName: 'Project',
    exportable: true,
    groupable: false,
    hideable: false,
    pinned: false,
    reorderable: {
      draggable: false,
    },
    resizable: true,
    sortable: false,
    width: 200,
    renamable: false,
    recolorable: false,
  },
  {
    id: 'workspace',
    // this type is just virtual as this column is represented by its own specific renderer
    columnType: 'string',
    displayName: 'Workspace',
    exportable: true,
    groupable: false,
    hideable: false,
    pinned: false,
    reorderable: {
      draggable: false,
    },
    resizable: true,
    sortable: false,
    width: 200,
    renamable: false,
    recolorable: false,
  },
  {
    id: NEPTUNE_COLUMN_IDS.CREATION_TIME,
    columnType: 'datetime',
    exportable: true,
    groupable: false,
    hideable: false,
    pinned: false,
    reorderable: {
      draggable: false,
    },
    resizable: true,
    sortable: true,
    width: 165,
    renamable: false,
    recolorable: false,
  },
  {
    id: NEPTUNE_COLUMN_IDS.TAGS,
    columnType: 'stringSet',
    exportable: true,
    groupable: true,
    hideable: false,
    pinned: false,
    reorderable: {
      draggable: false,
    },
    resizable: true,
    sortable: false,
    width: 200,
    renamable: false,
    recolorable: false,
  },
  {
    id: NEPTUNE_COLUMN_IDS.DESCRIPTION,
    columnType: 'string',
    exportable: true,
    groupable: true,
    hideable: false,
    pinned: false,
    reorderable: {
      draggable: false,
    },
    resizable: true,
    sortable: false,
    width: 200,
    renamable: false,
    recolorable: false,
  },
  {
    id: 'actions',
    // this type is just virtual as this column is represented by its own specific renderer
    columnType: 'string',
    exportable: false,
    groupable: false,
    hideable: false,
    pinned: false,
    reorderable: {
      draggable: false,
    },
    resizable: false,
    sortable: false,
    width: 42,
    renamable: false,
    recolorable: false,
  },
];

export function getMyRunsColumnSettings(
  columnIdentifier: ColumnIdentifier,
): ColumnSettings | undefined {
  return myRunsDefaultColumnsSettings.find((colSettings) =>
    columnIdentityComparator(colSettings, columnIdentifier),
  );
}
